import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import entity, { initialState as initialEntity } from "data/entity";

import assets, { initialState as initialAssets } from "data/assets";

import sections, { initialState as initialSections } from "data/sections";

import user, { initialState as initialUser } from "data/user";

import spreedly, { initialState as initialSpreedly } from "data/spreedly";

import givingReducer from "data/giving-form";

export const initialState = {
  entity: initialEntity,
  assets: initialAssets,
  sections: initialSections,
  user: initialUser,
  spreedly: initialSpreedly,
};

export default (asyncReducers) => {
  return combineReducers({
    entity,
    assets,
    sections,
    user,
    spreedly,
    form: formReducer,
    giving_form: givingReducer,
    ...asyncReducers,
  });
};
